/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';
import styles from './pagination.module.scss';
import '../../constants/_global.scss';
import { PaginationInterface } from './paginationTypes';
import ArrowButton from '../../UI/arrowButton/arrowComponent';
import { ARROW_DIRECTION } from '../../UI/arrowButton/arrowTypes';
import { useDispatch, useSelector } from '../..';
import { setPageNumber } from '../../service/ListingData';

const Pagination: React.FC<PaginationInterface> = ({
  clicker,
  maxPage,
  pageNumber,
}) => {
  // const pageNumber = useSelector((state) => state.listingData.pageNumber);
  // const dispatch = useDispatch();
  const [leftDisabled, setLeftDisabled] = useState<boolean>(true);
  const [rightDisabled, setRightDisabled] = useState<boolean>(false);
  const maxPageNumber = useSelector((state) => state.listingData.totalPages);
  useEffect(() => {
    setLeftDisabled(pageNumber <= 1);
  }, [pageNumber]);

  useEffect(() => {
    setRightDisabled(pageNumber === correctMaxPageNumber());
  }, [maxPageNumber, pageNumber]);

  const handleLeftClick = () => {
    const prevPageNumber = pageNumber;
    const newPageNumber = prevPageNumber - 1;
    clicker(newPageNumber);
    // dispatch(setPageNumber(newPageNumber));
  };

  const handleRightClick = () => {
    const prevPageNumber = pageNumber;
    const newPageNumber = prevPageNumber + 1;
    clicker(newPageNumber);
    // dispatch(setPageNumber(newPageNumber));
  };

  const correctPageNumber = () => {
    if (correctMaxPageNumber() === 0) {
      return 0;
    }

    return pageNumber;
  };

  const correctMaxPageNumber = () => {
    if (maxPage) {
      return maxPage;
    }
    return maxPageNumber;
  };

  const text = `${correctPageNumber()} из ${correctMaxPageNumber()}`;

  return (
    <div className={styles.shell}>
      <ArrowButton
        direction={ARROW_DIRECTION.left}
        disabled={leftDisabled}
        onClick={handleLeftClick}
      />
      <p className="spanGlobal">{text}</p>
      <ArrowButton
        direction={ARROW_DIRECTION.right}
        disabled={rightDisabled}
        onClick={handleRightClick}
      />
    </div>
  );
};

export default Pagination;
